var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item-dropdown',{staticClass:"dropdown-cart mr-25",attrs:{"menu-class":"dropdown-menu-media","right":""},on:{"show":_vm.fetchItems}})}
var staticRenderFns = []

export { render, staticRenderFns }